import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import {forwardRef} from 'react';
import ArrTooltip from '../../../common/arr-tooltip/ArrTooltip';
import {
  JSXElementConstructor,
  MouseEventHandler,
  ReactElement,
  SVGProps,
} from 'react';
import './ArrAudioWaveform.scss';

interface ArrAudioControlButtonProps {
  icon: ReactElement<
    SVGProps<SVGSVGElement>,
    string | JSXElementConstructor<any>
  >;
  toolTipText: string;
  ariaLabel: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
}

const ArrAudioControlButton = forwardRef<
  HTMLButtonElement,
  ArrAudioControlButtonProps
>((props, ref) => {
  const {icon, toolTipText, ariaLabel, disabled, onClick, onKeyDown} = props;

  return (
    <ArrTooltip content={toolTipText} contentClassName={'audio-tooltip'}>
      <ArrIconButton
        icon={icon}
        onClick={onClick}
        ariaLabel={ariaLabel}
        disabled={disabled}
        size={'small'}
        className={'arr-audio-waveform-control'}
        testId={`arr-audio-control-${ariaLabel}-icon-button`}
      />
    </ArrTooltip>
  );
});

export {ArrAudioControlButton};
